var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"log-browse mb-3 mt-page"},[_c('b-row',[_c('b-col',[_c('h1',[_vm._v(_vm._s(_vm.$i18n.gt('HEADING_VIEW_LOGS')))])])],1),_c('data-table',{ref:"dataTable",attrs:{"show-filters":true,"show-pager":true,"show-details":false,"get-items":_vm.getEntries,"filters":_vm.filters,"fields":_vm.fields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }